var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.26 20.14l-5.14-5-1.5 1.52 6.66 6.48 12.1-12-1.5-1.52zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c0-8.837-7.163-16-16-16v0zM16 29.86c-7.655 0-13.86-6.205-13.86-13.86s6.205-13.86 13.86-13.86c7.655 0 13.86 6.205 13.86 13.86v0c-0.011 7.65-6.21 13.849-13.859 13.86h-0.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCheckIcon);
export default __webpack_public_path__ + "static/media/task-check-icon.514322dcc14b024c4fa4121215f1cc66.svg";
export { ForwardRef as ReactComponent };